import {
  AppBar,
  Box,
  Button,
  Divider,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useEffect, useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenGrid from '../../../../global_components/KenGrid';
import KenPopover from '../../../../Components/KenPopOver';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDialogBox from '../../../../global_components/KenDialogBox';

import { RiFilterLine, RiCheckFill } from 'react-icons/ri';
import './quetionPaper.css';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AttachmentIcon from '@material-ui/icons/Attachment';
import SendIcon from '@material-ui/icons/Send';
import { Message, PictureAsPdf } from '@material-ui/icons';
import PdfImage from '../../../../Assets/pdf-image.png';
import {
  getQuestionPaperData,
  postQuestionPaperData,
} from '../../../../Utils/apiServices';

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'Question Paper',
  },
];

const ActionCellSendMessage = (row) => {
  const history = useHistory();
  const { id } = row.row.values;

  const handleClick = () => {
    history.push(`/app/exam/questionPaper/chat-history/${id}`);
  };

  return (
    <Message
      style={{
        color: '#092682',
      }}
      className="m-0"
      onClick={handleClick}
    />
  );
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { status } = row.row.values;

  let classOfBtn;
  if (status === 'Not Submitted') {
    classOfBtn = classes.errorText;
  } else if (status === 'Submitted') {
    classOfBtn = classes.submittedText;
  } else if (status === 'Under Review') {
    classOfBtn = classes.underReviewText;
  } else {
    classOfBtn = classes.approvedText;
  }

  return (
    <Box>
      <Button
        size="small"
        variant="primary"
        // component={Link}
        className={classOfBtn}
        // to={`${routes.currentCoursemes}/${id}/details`}
      >
        {status}
      </Button>
    </Box>
  );
};

// const ActionCell = (row) => {
//   const classes = useStyles();
//   const { status } = row.row.values;

//   console.log('row--==-=-=-=-=-=-=-=-', row.row.original);
//   // View Modal
//   const [viewDialog, setViewDialog] = useState(false);
//   // const [first, setfirst] = useState(false);
//   function handleViewDialog() {
//     setViewDialog((prevState) => !prevState);
//   }

//   const handleClick = () => {
//     handleViewDialog();
//   };

//   const onApproveQuestionPaper = () => {
//     console.log('object');

//     const payload = [
//       {
//         id: row.row.original.id,
//         status: 'Approved',
//       },
//     ];

//     postQuestionPaperData(payload)
//       .then((res) => {
//         // getQuestionPaperData();
//       })
//       .catch((err) => {
//         alert('Failed to add. Please try again.');
//       });
//     // setfirst(true);
//   };

//   // useEffect(() => {
//   //   onApproveQuestionPaper();
//   // }, [first]);

//   return (
//     <Box>
//       {status === 'Not Submitted' && (
//         <Button
//           className={classes.error}
//           size="small"
//           variant="primary"
//           // to={`${routes.currentProgrammes}/${id}/details`}
//         >
//           Remind
//         </Button>
//       )}
//       {(status === 'Submitted' ||
//         status === 'Under Review' ||
//         status === 'Approved') && (
//         <Button
//           className={classes.view}
//           size="small"
//           variant="primary"
//           onClick={handleClick}
//           // to={`${routes.currentProgrammes}/${id}/details`}
//         >
//           View
//         </Button>
//       )}
//       {(status === 'Submitted' || status === 'Under Review') && (
//         <>
//           <Button
//             className={classes.normal}
//             size="small"
//             variant="primary"
//             onClick={() => onApproveQuestionPaper()}
//             // value={}
//           >
//             Approve
//           </Button>
//           <Button
//             className={classes.review}
//             size="small"
//             variant="primary"
//             component={Link}
//             // to={`${routes.currentProgrammes}/${id}/details`}
//           >
//             Review
//           </Button>
//         </>
//       )}
//       {/* Question Paper Modal */}
//       <KenDialogBox
//         title={
//           <Typography variant="h6" className={classes.dialogHeader}>
//             View Question Paper
//           </Typography>
//         }
//         open={viewDialog}
//         handleClose={() => handleViewDialog()}
//         negativeButtonClick={() => handleViewDialog()}
//         positiveButtonClick={() => handleViewDialog()}
//         hideNegativeButton={true}
//         hidePositiveButton={true}
//         dividers
//       >
//         <Grid
//           xs={12}
//           alignItems="center"
//           justifyContent="space-between"
//           container
//         >
//           <Typography variant="h6" className={classes.dialogHeader}>
//             Course:{' '}
//           </Typography>

//           <Typography variant="p" className={classes.dialogHeader}>
//             UX/UI Design
//           </Typography>
//         </Grid>
//         <Divider />

//         <Grid
//           xs={12}
//           alignItems="center"
//           justifyContent="space-between"
//           container
//         >
//           <Typography variant="h6" className={classes.dialogHeader}>
//             Faculty:{' '}
//           </Typography>
//           <Typography variant="p" className={classes.dialogHeader}>
//             Nandhini Clament
//           </Typography>
//         </Grid>
//         <Divider />

//         <Grid
//           xs={12}
//           alignItems="center"
//           justifyContent="space-between"
//           container
//         >
//           <Typography variant="h6" className={classes.dialogHeader}>
//             Term:{' '}
//           </Typography>
//           <Typography variant="p" className={classes.dialogHeader}>
//             Term II
//           </Typography>
//         </Grid>
//         <Divider />

//         <Typography
//           variant="h6"
//           className={classes.dialogHeader}
//           style={{ fontSize: '58px', margin: '25px' }}
//         >
//           <img src={PdfImage} alt="pdf" />
//         </Typography>
//       </KenDialogBox>
//     </Box>
//   );
// };

// const columns = [
//   {
//     Header: 'id',
//     accessor: 'id',
//     disableGlobalFilter: true,
//   },
//   {
//     Header: 'COURSE NAME',
//     accessor: 'courseName',
//     disableGlobalFilter: true,
//   },
//   {
//     Header: 'TERM',
//     accessor: 'term',
//     disableGlobalFilter: true,
//   },
//   {
//     Header: 'FACULTY',
//     accessor: 'faculty',
//     disableGlobalFilter: true,
//   },
//   {
//     Header: 'STATUS',
//     accessor: 'status',
//     disableGlobalFilter: true,
//     Cell: CellWithButton,
//   },
//   {
//     Header: 'ACTIONS',
//     accessor: 'actions',
//     disableGlobalFilter: true,
//     Cell: ActionCell,
//   },
//   {
//     Header: 'CHAT HISTORY',
//     accessor: 'chatHistory',
//     disableGlobalFilter: true,
//     Cell: ActionCellSendMessage,
//   },
// ];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    color: theme.palette.KenColors.primary,
    padding: '0',
    backgroundColor: '#fff',
    marginBottom: '10px',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    paddingLeft: '10px',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    // '&:hover': {
    //   color: 'pink',
    //   borderBottom: '1px solid pink',
    // },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: '#c12002',
    height: '23px',
    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',
    },
    // color: '#FFF',
    // background: '#EB5757',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#be6f6f',
    //   borderBottom: '1px solid #be6f6f',
    // },
  },
  normal: {
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFF',
    // background: '#27AE60',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#84e2ac',
    //   borderBottom: '1px solid #84e2ac',
    // },
  },
  view: {
    color: '#00218D',

    background: 'rgba(0, 33, 141,0.2)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(0, 33, 141,0.2)',

      color: '#00218D',
    },
    // color: '#FFF',
    // background: '#00218D',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: 'grey',
    //   borderBottom: '1px solid grey',
    // },
  },
  review: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
    // color: '#FFF',
    // background: '#F2994A',
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // '&:hover': {
    //   color: 'white',
    //   background: '#dab391',
    //   borderBottom: '1px solid #dab391',

    //#dab391
  },
  errorText: {
    color: '#F14B2D',
    fontSize: '12px',
  },
  submittedText: {
    fontSize: '12px',
    color: '#27AE60',
  },
  underReviewText: {
    fontSize: '12px',
    color: '#F2994A',
  },
  approvedText: {
    fontSize: '12px',
    color: '#00218D',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Select Course',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
];

const selectOptionsStatus = [
  {
    label: 'Select Campus',
    value: '',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Request Sent',
    value: 'Request Sent',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
  {
    label: 'Under Review',
    value: 'Under review',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Component',
    value: '',
  },
  {
    label: 'MACRO TERM 1',
    value: 'MACRO TERM 1',
  },
];

const selectOptionsFaculty = [
  {
    label: 'Select Faculty',
    value: '',
  },
  {
    label: 'Ganesh',
    value: 'Ganesh',
  },
];

const ActionCell = ({ row, onApproveStatus }) => {
  const classes = useStyles();
  const { status } = row.row.values;
  const history = useHistory();
  const id = row.row.original.id;
  console.log('ididid', id);

  const handleClickView = () => {
    history.push(`/app/exam/questionPaper/question-paper-view/${id}`);
  };

  console.log('row--==-=-=-=-=-=-=-=-', row.row.original);
  // View Modal
  const [viewDialog, setViewDialog] = useState(false);
  // const [first, setfirst] = useState(false);
  function handleViewDialog() {
    setViewDialog((prevState) => !prevState);
  }

  const handleClick = () => {
    handleViewDialog();
  };

  const onApproveQuestionPaper = () => {
    console.log('object');

    const payload = [
      {
        id: row.row.original.id,
        status: 'Approved',
      },
    ];

    postQuestionPaperData(payload)
      .then((res) => {
        onApproveStatus();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
    // setfirst(true);
  };

  // useEffect(() => {
  //   onApproveQuestionPaper();
  // }, [first]);

  return (
    <Box>
      {(status === 'Approved' ||
        status === 'Under review' ||
        status === 'Submitted' ||
        status === 'Request Sent') && (
        <Button
          className={classes.view}
          size="small"
          variant="primary"
          // component={Link}
          onClick={() => {
            handleClickView();
          }}
          // to={`${routes.questionPaperView}`}
        >
          View
        </Button>
      )}
      {(status === 'Request Sent' ||
        status === 'Under review' ||
        status === 'Submitted') && (
        <>
          <Button
            className={classes.normal}
            size="small"
            variant="primary"
            onClick={() => onApproveQuestionPaper()}
            // value={}
          >
            Approve
          </Button>
          {/* <Button
            className={classes.review}
            size="small"
            variant="primary"
            component={Link}
            // to={`${routes.currentProgrammes}/${id}/details`}
          >
            Review
          </Button> */}
        </>
      )}
      {(status === 'Request Sent' ||
        status === 'Under review' ||
        status === 'Submitted') && (
        <Button
          className={classes.error}
          size="small"
          variant="primary"
          // to={`${routes.currentProgrammes}/${id}/details`}
        >
          Remind
        </Button>
      )}
      {/* Question Paper Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            View Question Paper
          </Typography>
        }
        open={viewDialog}
        handleClose={() => handleViewDialog()}
        negativeButtonClick={() => handleViewDialog()}
        positiveButtonClick={() => handleViewDialog()}
        hideNegativeButton={true}
        hidePositiveButton={true}
        dividers
      >
        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Course:{' '}
          </Typography>

          <Typography variant="p" className={classes.dialogHeader}>
            UX/UI Design
          </Typography>
        </Grid>
        <Divider />

        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Faculty:{' '}
          </Typography>
          <Typography variant="p" className={classes.dialogHeader}>
            Nandhini Clament
          </Typography>
        </Grid>
        <Divider />

        <Grid
          xs={12}
          alignItems="center"
          justifyContent="space-between"
          container
        >
          <Typography variant="h6" className={classes.dialogHeader}>
            Term:{' '}
          </Typography>
          <Typography variant="p" className={classes.dialogHeader}>
            Term II
          </Typography>
        </Grid>
        <Divider />

        <Typography
          variant="h6"
          className={classes.dialogHeader}
          style={{ fontSize: '58px', margin: '25px' }}
        >
          <img src={PdfImage} alt="pdf" />
        </Typography>
      </KenDialogBox>
    </Box>
  );
};

const QuestionPaper = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterDialog, setFilterDialog] = useState(false);
  const [questionData, setquestionData] = useState([]);

  const columns = [
    // {
    //   Header: 'id',
    //   accessor: 'id',
    //   disableGlobalFilter: true,
    // },
    {
      Header: 'COURSE NAME',
      accessor: 'courseName',
      disableGlobalFilter: true,
    },
    {
      Header: 'TERM',
      accessor: 'term',
      disableGlobalFilter: true,
    },
    {
      Header: 'FACULTY',
      accessor: 'faculty',
      disableGlobalFilter: true,
    },
    {
      Header: 'STATUS',
      accessor: 'status',
      disableGlobalFilter: true,
      Cell: CellWithButton,
    },
    {
      Header: 'ACTIONS',
      accessor: 'actions',
      disableGlobalFilter: true,
      Cell: (row) => (
        <ActionCell row={row} onApproveStatus={getQuestionPaperDatas} />
      ),
    },
    {
      Header: 'CHAT HISTORY',
      accessor: 'chatHistory',
      disableGlobalFilter: true,
      Cell: ActionCellSendMessage,
    },
  ];

  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [selectValueStatus, setSelectValueStatus] = useState(
    selectOptionsStatus[0].value
  );
  const handleSelectChangeStatus = (e) => {
    setSelectValueStatus(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const [selectValueFaculty, setSelectValueFaculty] = useState(
    selectOptionsFaculty[0].value
  );
  const handleSelectChangeFaculty = (e) => {
    setSelectValueFaculty(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onApproveQuestionPaper = () => {
    console.log('object');
    const newData = [...questionData];

    const payload = newData.map((row) => {
      return {
        id: row.id,
        status: row.status,
      };
    });

    postQuestionPaperData(payload)
      .then((res) => {
        getQuestionPaperDatas();
      })
      .catch((err) => {
        alert('Failed to add. Please try again.');
      });
  };

  const getQuestionPaperDatas = () => {
    let filterData = {
      course: selectValueCourse,
      status: selectValueStatus,
      term: selectValueTerm,
      faculty: selectValueFaculty,
    };
    getQuestionPaperData(filterData).then((res) => {
      console.log('resForStudentStatus', res);
      const QuestionPaperInfo =
        res === null
          ? []
          : res.map((item, index) => {
              console.log('itemitem', item);
              return {
                id: item.id,
                courseName: item.courseName ? item.courseName : 'NA',
                term: item.term ? item.term : 'NA',
                faculty: item.faculty ? item.faculty : 'NA',
                status: item.status ? item.status : 'NA',
              };
            });

      setquestionData(QuestionPaperInfo);
      setFilterDialog(false);
    });
  };
  useEffect(() => {
    getQuestionPaperDatas();
  }, []);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>

      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Question Paper
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={`${classes.gridKenClass} cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={questionData}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            gridProps={{
              getCellProps: (row) => {
                if (row.column.Header === 'CHAT HISTORY') {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (column.Header === 'CHAT HISTORY') {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box>

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getQuestionPaperDatas()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectOptionsCourse}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCourse}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsStatus}
              value={selectValueStatus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeStatus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Component"
              options={selectOptionsTerm}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Faculty"
              options={selectOptionsFaculty}
              value={selectValueFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeFaculty}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};

export default QuestionPaper;
